































































































import {
  SfList,
} from '@storefront-ui/vue'
import DsbOrderListItem from "~/modules/customer/components/Orders/DsbOrderListItem.vue";
import DsbOrderDetailItem from "~/modules/customer/components/Orders/DsbOrderDetailItem.vue";
import CancelOrderModal from '~/modules/customer/components/Orders/Cancelation/CancelOrderModal.vue'
import CancelOrderItemModal from '~/modules/customer/components/Orders/Cancelation/CancelOrderItemModal.vue'
import {PageCategory} from '~/types/PageCategory'
import {OrderDeliveryStatus, OrderDetails} from '~/types/orders/OrdersCategories'
import {getFormattedDate} from '~/utils/dateFormatter'
import {ProductDetailType} from "~/types/ProductData";
import DsbConfirmationModal from "~/components/Modal/DsbConfirmationModal.vue";
import DsbNotification from '~/components/DsbNotification.vue'
import productGetters from "~/modules/catalog/product/getters/productGetters";
import orderStatusGetter from "~/modules/customer/getters/orderStatusGetter";
import {computed, ref} from '@nuxtjs/composition-api'

export default {
  name: 'DsbOrderShipments',
  components: {
    DsbOrderListItem,
    DsbOrderDetailItem,
    SfList,
    DsbConfirmationModal,
    DsbNotification,
    CancelOrderModal,
    CancelOrderItemModal
  },
  props: {
    shipments: {
      required: true,
      type: Array,
    },
    orderItems: {
      required: true,
      type: Array,
    },
    outstandingOrderItems: {
      type: Array,
      default: []
    },
    orderStatusComplete: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: String,
      default: ''
    },
    orderStatus: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const shipmentsHeading = props.shipments.length === 1 ? 'Lieferung' : `${props.shipments.length} Lieferungen`

    function mapShipmentItems(shipment) {
      const getProduct = (sku: string) => {
        return props.orderItems.find(item => item.product_sku === sku)
      }

      const shipmentItems = shipment.items.map(item => ({
        sku: item.product_sku,
        name: item.product_name,
        text: '',
        imgSrc: productGetters.getProductThumbnailImage( getProduct(item.product_sku)?.product),
        orderItemStatus: orderStatusGetter.getOrderItemStatus(item),
        details: [
          {
            type: ProductDetailType.ARTICLE_NUMBER,
            text: productGetters.getProductSkuFormatted(item?.product, item.product_sku)
          },
          {
            type: ProductDetailType.ORDERED_QUANTITY,
            text: item.quantity_shipped
          },
          {
            type: ProductDetailType.DELIVERY_STATUS,
            text: orderStatusGetter.getOrderItemStatus(item.order_item)
          }
        ],
      }))

      return shipmentItems
    }

    function mapOutstandingOrderItems() {
      const items = props.outstandingOrderItems.map(item => ({
        sku: item.product_sku,
        name: item.product_name,
        text: '',
        imgSrc: productGetters.getProductThumbnailImage(item?.product),
        orderItemStatus: orderStatusGetter.getOrderItemStatus(item),
        orderItemId: item.id,
        product: item.product,
        details: [
          {
            type: ProductDetailType.ARTICLE_NUMBER,
            text: productGetters.getProductSkuFormatted(item?.product, item.product_sku)
          },
          {
            type: ProductDetailType.ORDERED,
            text: item.quantity_ordered
          },
          {
            type: ProductDetailType.OUTSTANDING,
            text: item.quantity_ordered - item.quantity_shipped - item.quantity_canceled - item.quantity_returned
          },
          {
            type: ProductDetailType.DELIVERY_STATUS,
            text: orderStatusGetter.getOrderItemStatus(item)
          }
        ],
      }))

      return items
    }

    const mapOutstandingOrderItemsToCancel = () => {
      const items = props.outstandingOrderItems.map(item => ({
        sku: item.product_sku,
        name: item.product_name,
        text: '',
        imgSrc: productGetters.getProductThumbnailImage(item?.product),
        details: [
          {
            type: ProductDetailType.ARTICLE_NUMBER,
            text: productGetters.getProductSkuFormatted(item?.product, item.product_sku)
          }
        ],
      }))

      return items
    }

    function getTrackingNumber(tracking) {
      return tracking[0]?.number || ''
    }

    function getTrackingLink(tracking) {
      if (tracking[0]?.title) {
        if (tracking[0]?.title.startsWith('http') || tracking[0]?.title.startsWith('//')) {
          return tracking[0]?.title
        }
        return '//' + tracking[0]?.title
      }

      return '#'
    }

    const openCancelOrderModal = ref(false)

    const confirmCancelOrder = () => {
      openCancelOrderModal.value = true
    }

    const closeCancelOrderModal = () => {
      openCancelOrderModal.value = false
    }

    const isOrderInProcess = () => {
      return (props.orderStatus === OrderDeliveryStatus.PROCESSING)
    }

    const isAnyOrderItemShipped = () => {
      return props.shipments.length > 0
    }

    const isAnyOrderItemShippedOrCanceled = () => {
      const orderItemStatus = props.outstandingOrderItems.filter(item => {
        return (orderStatusGetter.getOrderItemStatus(item) !== OrderDeliveryStatus.ORDERED)
      })

      return (orderItemStatus.length > 0)
    }

    const isCancelOrderButtonActive = computed(() => {
      return (
        isOrderInProcess() &&
        !isAnyOrderItemShipped() &&
        !isAnyOrderItemShippedOrCanceled())
    })

    return {
      PageCategory,
      OrderDetails,
      getFormattedDate,
      shipmentsHeading,
      mapShipmentItems,
      mapOutstandingOrderItems,
      mapOutstandingOrderItemsToCancel,
      getTrackingNumber,
      getTrackingLink,
      confirmCancelOrder,
      openCancelOrderModal,
      closeCancelOrderModal,
      isCancelOrderModalVisible: computed(() => {
        return openCancelOrderModal.value
      }),
      isCancelOrderButtonActive
    }
  },
}
